import { useContext } from 'react';
import { createContext } from 'react';

import { ImageProps } from '../@types/ImageProps';

export const ImageContext = createContext<ImageProps>({} as ImageProps);

ImageContext.displayName = 'Image';

const ImageProvider = (props: ImageProps) => (
	<ImageContext.Provider value={props}>{props.children}</ImageContext.Provider>
);

export const useImage = () => {
	const context = useContext(ImageContext);

	return context;
};

export default ImageProvider;
